import React from 'react';
import './ContactUs.css';

function ContactUs() {
  return (
    <div className="contact-us">
      <h1 className="contact-title">Contact Us</h1>
      <p className="contact-desc">
        Have a question, suggestion, or want to get in touch with the Knowledge Buddy team? We'd love to hear from you! Fill out the form below or use the contact details to reach us directly.
      </p>
      <div className="contact-info">
        <span>
          <img src="https://img.icons8.com/fluency/48/000000/new-post.png" alt="Email Icon" />
          <a href="mailto:hello@knowledgebuddy.com" style={{color:'#38b2ac', textDecoration:'underline'}}>hello@knowledgebuddy.com</a>
        </span>
        <span>
          <img src="https://img.icons8.com/fluency/48/000000/marker.png" alt="Location Icon" />
          San Francisco, CA, USA
        </span>
      </div>
      <div id="contact-success" className="contact-success">
        Thank you for reaching out! We'll get back to you soon.
      </div>
      <form className="contact-form" id="contactForm" autoComplete="off">
        <div>
          <label htmlFor="name">Your Name</label><br />
          <input type="text" id="name" name="name" required placeholder="Enter your name" />
        </div>
        <div>
          <label htmlFor="email">Your Email</label><br />
          <input type="email" id="email" name="email" required placeholder="Enter your email" />
        </div>
        <div>
          <label htmlFor="message">Message</label><br />
          <textarea id="message" name="message" rows="5" required placeholder="Type your message here"></textarea>
        </div>
        <button type="submit">Send Message</button>
      </form>
    </div>
  )
}

export default ContactUs